import { BaseModel } from '../base.model';
import { required } from '../json-map.util';

class ExerciseRequest {
}

namespace ExerciseRequest {


  export class Create extends BaseModel {
    @required()
    lessonId: number = undefined;
    @required()
    title: string = undefined;
    introCopy: string = undefined;
    completeCopy: string = undefined;
    description: string = undefined;
    problemIds: number[] = undefined;
    subject: string = undefined;
    accuracyGoal: number = undefined;
    pacingGoal: number = undefined;
    videoLink: string = undefined;
    showOpenAnswerEnabled = undefined;
    openAnswerPrompt = undefined;
  }

  export class Update extends BaseModel {
    lessonId: number = undefined;
    title: string = undefined;
    description: string = undefined;
    introCopy: string = undefined;
    completeCopy: string = undefined;
    problemIds: number[] = undefined;
    subject: string = undefined;
    accuracyGoal: number = undefined;
    pacingGoal: number = undefined;
    videoLink: string = undefined;
    showOpenAnswerEnabled = undefined;
    openAnswerPrompt = undefined;
  }

}

export { ExerciseRequest };

